import { css } from "styled-components";

export const InputCSS = css`
  text-align: center;
  width: 30px;
  padding: 0;
  height: 30px;
  border-radius: 4px;
  border: 1px solid ${(p) => p.theme["gray-6"]};
  background: ${(p) => p.theme["gray-4"]};
  box-sizing: border-box;
  :hover {
    border: 1px solid var(--main-color);
    background: ${(p) => p.theme["gray-4"]};
  }
  :focus {
    background: #1a1c1f;
    border: 1px solid var(--main-color);
  }
  ::placeholder {
    color: #656e71;
  }
  &[disabled] {
    border: 1px solid #3c3e44;
    background: #303134;
    cursor: not-allowed;
  }
  &.error {
    border-color: ${(p) => p.theme["red-1"]};
  }
`;
